module.exports = __webpack_public_path__ + "static/Buy-Low-Foods-3645b701d9c76b875e584a33460ee3e6.jpeg";